import { render, staticRenderFns } from "./Statistics.container.vue?vue&type=template&id=4a5643f3&scoped=true&"
import script from "./Statistics.container.vue?vue&type=script&lang=js&"
export * from "./Statistics.container.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.container.vue?vue&type=style&index=0&id=4a5643f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5643f3",
  null
  
)

export default component.exports